// extracted by css-extract-rspack-plugin
export default {"groupLabel":"C90EExdafmIb0o8P"};